import * as React from 'react';
import { AccordionPanel, Box, ThemeContext, Text } from 'grommet';
import { theme } from './DocumentLocation';
import ReusablePanel from './ReusablePanel';

type Props = {
  activeIndex: number[];
  documentLocation: any;
  saveDocumentLocation: (updated: any) => Promise<void>;
  closeAccordion: () => void;
  accordionIndex: number;
};

const EnduringPowerofAttorneyPanel: React.FunctionComponent<Props> = ({
  activeIndex,
  documentLocation,
  saveDocumentLocation,
  closeAccordion,
  accordionIndex,
}: Props) => {
  const onSave = (updated) => {
    documentLocation.epoa = updated;
    saveDocumentLocation(documentLocation);
  };

  const label = () => {
    const label = 'Enduring Power of Attorney';
    if (documentLocation?.epoa?.label) {
      return (
        <Text>
          {label} - <Text weight="bold">{documentLocation.epoa.label}</Text>
        </Text>
      );
    }
    return <Text>{label}</Text>;
  };

  return (
    <ThemeContext.Extend value={theme(documentLocation?.epoa?.saved)}>
      <Box
        pad="medium"
        fill
        background={activeIndex && activeIndex[0] === accordionIndex ? '' : '#F9FDFF'}
        border={{ color: '#C4D0D6', side: 'bottom' }}
        round={{ size: '1%', corner: 'bottom' }}
      >
        <AccordionPanel style={{ maxWidth: 'none' }} label={label()}>
          <ReusablePanel docTypeData={documentLocation.epoa} onSave={onSave} closeAccordion={closeAccordion} />
        </AccordionPanel>
      </Box>
    </ThemeContext.Extend>
  );
};

export default EnduringPowerofAttorneyPanel;
